// removed by extract-text-webpack-plugin
module.exports = {"ellipsis":"mMkhwJl14PGzewJiRfhhu"};


//////////////////
// WEBPACK FOOTER
// ./src/projects/easy/public/Comps/app/AppText.scss
// module id = 927
// module chunks = 12